/* eslint-disable no-undef */

import { logDebugging, logError } from '../log/logger';

export function isValidUrl(url) {
  try {
    return new URL(url);
  } catch (error) {
    return false;
  }
}

/**
 * returns an object with query params of the url
 * if there is no params, returns null
 * @param {String} url
 * @returns object or null
 */
export function getParametersFromUrl(url) {
  // eslint-disable-next-line no-undef
  const query = typeof url === 'undefined' ? window.location.search.substring(1) : url;
  const aux = query.split('?');
  const paramsString = aux.length > 0 ? aux.slice(1, aux.length).join() : null;
  try {
    if (paramsString) {
      return JSON.parse(
        `{"${decodeURIComponent(paramsString.replace(/&/g, '","').replace(/=/g, '":"'))}"}`,
      );
    }
  } catch (error) {
    logDebugging('Params from url not get');
  }

  return null;
}

export function getParentUrlOrigin() {
  try {
    return window.top.location.href;
  } catch (error) {
    logError('This is an sandboxed iframe, no parent origin available');
    const locationAreDisctint = window.location !== window.parent.location;
    const parentOrigin = (
      (locationAreDisctint ? document.referrer : document.location) || ''
    ).toString();

    if (isValidUrl(parentOrigin)) {
      return parentOrigin;
    }

    const currentLocation = document.location;

    if (currentLocation.ancestorOrigins && currentLocation.ancestorOrigins.length) {
      return currentLocation.ancestorOrigins[0];
    }

    return '';
  }
}

export function getDomainFromUrl(url) {
  // eslint-disable-next-line no-undef
  const parser = document.createElement('a');
  parser.href = url;
  const { protocol, hostname, port } = parser;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

export function getHostName(url) {
  if (url) {
    return new URL(url).hostname;
  }
  return false;
}

export function getDayNumber() {
  const d = new Date();
  const n = d.getDate();
  const m = d.getMonth();
  const y = d.getFullYear();
  return `${n}${m}${y}`;
}
